import { takeEvery, select, put } from "redux-saga/effects";

import { prefixes } from "./types";
import { actionsFor } from "./actions";
import { selectorsFor } from "./selectors";
import { prefixed } from "utils";

// asc -> desc -> null -> asc
const nextOrder = order => {
  const next = {
    asc: "desc",
    desc: null
  }[order];
  return next !== undefined ? next : "asc";
};

export function* changeSort(action) {
  const { setSort } = actionsFor(action.meta.domain);

  let field = action.payload;
  if (field === null) {
    return yield put(setSort(null));
  }

  const { getSortField, getSortType } = selectorsFor(action.meta.domain);
  const currentField = yield select(getSortField);
  const currentOrder = yield select(getSortType);

  let order = nextOrder(currentOrder);

  if (field !== currentField) {
    order = nextOrder(null);
  }

  yield put(setSort(field, order));
}

const sagas = [takeEvery(prefixed(prefixes.CHANGE_SORT), changeSort)];

export default sagas;
